import { getCatalogs } from '@api/FW/common/catalogs';
import { saveLocalStorageData } from '@app/services/localStorage.service';
import { LocalStorageItems } from '@app/shared/constants/localStorageItems';
import { CatalogsGoods, CatalogsMethod } from '@interfaces/FW/common/Catalogs';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export interface NomenclatureSlice {
	data: CatalogsGoods[];
}

export const doGetNomenclature = createAsyncThunk(
	'getNomenclature',
	async (payload: undefined, { rejectWithValue }) =>
		getCatalogs(CatalogsMethod.goods)
			.then((res) => {
				saveLocalStorageData(LocalStorageItems.nomenclature, res);
				return res;
			})
			.catch((err) => {
				return rejectWithValue(err);
			}),
);

const nomenclatureSlice = createSlice({
	name: 'nomenclature',
	initialState: { data: [] as CatalogsGoods[] } as NomenclatureSlice,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(doGetNomenclature.fulfilled, (state, action) => {
			state.data = action.payload as CatalogsGoods[];
		});
	},
});

export default nomenclatureSlice.reducer;
